import React from 'react';
import './GameField.css'; // Используем существующие стили

/**
 * Компонент для отображения подсказки на пустом игровом поле
 */
const GameFieldHint: React.FC = () => {
  return (
    <div className="game-field-hint">
      Перетащите элементы сюда и комбинируйте их для создания новых элементов
    </div>
  );
};

export default GameFieldHint; 